import axios from 'axios';
import { trackBusyRequests } from '@sf/shared';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  withCredentials: true,
});

// Gravações em curso bloqueiam a atualização automática do PWA
trackBusyRequests(api);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url ?? '';

    if (status === 401 && !url.includes('/login') && !url.includes('/logout')) {
      localStorage.removeItem('user');
      localStorage.removeItem('companyId');
      window.location.href = '/login';
      return Promise.reject(error);
    }

    if (status === 403) {
      localStorage.removeItem('user');
      localStorage.removeItem('companyId');
      window.location.href = '/login';
      return Promise.reject(error);
    }

    if (status === 429) {
      // Rate limit atingido — rejeita com mensagem legível para o componente tratar
      const err = new Error('Muitas tentativas. Aguarde um momento antes de tentar novamente.');
      err.isRateLimit = true;
      err.response = error.response;
      return Promise.reject(err);
    }

    return Promise.reject(error);
  }
);

export default api;
